<template>
    <div
        class="w-full h-screen rounded-lg flex flex-col justify-start items-center p-8 mt-6"
    >
        <HeaderIcon :show-rings="false" :inner-color="'#2D8A39'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#41AE49" style="opacity:1;"><path  d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10m5.457-12.543L11 15.914l-4.207-4.207l1.414-1.414L11 13.086l5.043-5.043z"/></svg>
        </HeaderIcon>

        <div class="w-full max-w-lg flex flex-col justify-center items-center mt-8 z-50">
            <Intro :heading-text="headingText" :sub-text="subText" />
        </div>

    </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useSignupWizardStore } from "@/store";
import HeaderIcon from "@/components/auth/components/HeaderIcon.vue";
import Intro from "@/components/auth/components/Intro.vue";

const signupWizardStore = useSignupWizardStore();
const { fetchSignupState, redirectToCreatePassword } = signupWizardStore;

const headingText = "Signup Completed";
const subText =
"Congrats, you details have successfully been created, You will be redirected to create a password shortly.";
    
onMounted(async () => {
    await fetchSignupState();

    setTimeout(() => {
        redirectToCreatePassword();
    }, 1000);
});
</script>
